<!--<script
        src="https://www.paypal.com/sdk/js?client-id=ATZGT8QrikMkDp0KFJKhpWPEIlUFw3r30xSouzL2-Nr-CtDtUuNQNFV_8lMPSgNfaXqgQfZFElV2eJtb">
</script>
-->


<mat-card>
  <mat-card-content>
    <mat-card-title>
      Richiesta di adesione al Gii
    </mat-card-title>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>
    <!--
    <div style="width:100%; background-color:#ffffff; text-align:center; border:1px solid green;" *ngIf="isEdit">
      <div class="row">
        <img src="./assets/images/OK.png" width="50" height="50" />
      </div>

      <div class="row" style="text-align: left;">
        La richiesta di adesione è stata correttamente completata. Un email è stata inviata al suo indirizzo di posta
        elettronica con le istruzioni del pagamento e allegato l'avviso di pagamento.
        <br /> <strong>ATTENZIONE:</strong> Dopo aver effettuato il pagamento, è necessario comunicare i codici identificativi
        del pagamento cliccando su "Conferma il pagamento"
      </div>
    </div>
    <br />-->
    <div style="width:100%; text-align:center;">
      <strong> Importo da pagare: </strong> {{objcalcolo}},00
    </div>

    <p><strong>Paypal</strong></p>



    <mat-hint>N.B. Si prega di specificare dipartimento, ateneo e periodo di adesione nel campo "Aggiungi istruzioni speciali per il venditore".</mat-hint>
    <br /><br />

    <ngx-paypal [config]="payPalConfig"></ngx-paypal>

    

    <p><strong>Bonifico Bancario</strong></p>
    <p>Intestato a "Gruppo Italiano di Idraulica", Unicredit Banca, Agenzia Politecnico, Torino (TO)</p>
    <p><strong>c/c</strong> 000102446219</p>
    <p><strong>ABI</strong> 02008</p>
    <p><strong>CIN</strong> G</p>
    <p><strong>IBAN</strong> IT63G0200801160000102446219</p>

    <button mat-raised-button color="primary" (click)="btnConfermaIlPagamento()">Conferma il pagamento</button>

  </mat-card-content>
</mat-card>

